import React, { useState } from 'react';
import MsgHistory from '../MsgHistory';
import AutocompleteSearch from '../../components/AutocompleteSearch';

const Search = () => {
  const [msgHistory, setMsgHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  // receives user search input or search api result
  // add object to msg history
  const onSearchOrResult = (obj) => {
    // console.log('onSearchOrResult: ', obj);
    msgHistory.push(obj);
    setMsgHistory([...msgHistory]);
  };

  return (
    <>
      <MsgHistory data={msgHistory} loading={loading} />
      <br />
      <AutocompleteSearch onSearchOrResult={onSearchOrResult} loading={loading} setLoading={setLoading} />
    </>
  );
};

export default Search;
